// Centralized resource data for the resources section
export const resourcesData = {
  // Featured Resources
  featured: [
    {
      id: 1,
      title: "Crisis Response Outreach Templates",
      category: "Templates",
      description:
        "Quickly connect with donors during urgent needs using these prewritten customizable messages",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(25).png",
      downloadUrl: "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-RapidCrisis%20Response%20Outreach%20Templates.pdf",
    },
    {
      id: 2,
      title: "Matching Gift Templates",
      category: "Templates",
      description:
        "Double your impact with these ready-to-use templates for matching gift campaigns",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(26).png",
      downloadUrl: "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Matching%20Gift%20Guide%20(1).pdf",
    },
  ],

  // Maximize Results
  maximize: [
    {
      id: 4,
      title: "Silent Auction Bid Sheets",
      category: "Sheets",
      description:
        "Professional bid sheets to maximize your silent auction revenue and organization",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(28).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/auction/Freebie-Auction-Silent%20Auction%20Bid%20Sheet.pdf",
    },
    {
      id: 5,
      title: "Auction Rules Template",
      category: "Templates",
      description:
        "Clear, comprehensive rules template to ensure smooth auction operations",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(29).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/auction/Freebie-Auction-Silent%20Auction%20Rules%20Sheet%20Template.pdf",
    },
    {
      id: 6,
      title: "Auction Donation Request Letters",
      category: "Templates",
      description:
        "Professional letters to request donations for your auction events",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(30).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/auction/Freebie-Auction-Silent%20Auction%20Donation%20Request%20Letter%20Template%20(1).pdf",
    },
  ],

  // Organize Fundraising Event
  organize: [
    {
      id: 7,
      title: "Event Season Workflow Guide",
      category: "Guides",
      description:
        "A guide to streamlining your team's workflow for busy event seasons",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(31).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/events/Freebie-Events-Event%20Toolkit%20%26%20Workflow%20Guide%20for%20Nonprofits%20(1).pdf",
    },
    {
      id: 8,
      title: "Fundraising Event Planning Checklist",
      category: "Checklists",
      description:
        "Everything you need to plan and track successful fundraising event",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(32).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/events/Freebie-Events-Fundraising%20Event%20Planning%20Checklist%20(1).pdf",
    },
    {
      id: 9,
      title: "Gala Invitation Templates",
      category: "Templates",
      description:
        "Professional invitation designs with all the must-have details already included",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(33).png",
      downloadUrl: "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/events/Freebie-Events-Gala%20Invitation%20Template%20(1).pdf",
    },
    {
      id: 24,
      title: "Charity Golf Tournament Checklist",
      category: "Checklists",
      description:
        "Plan a seamless tournament with this 8-step template designed for maximum impact",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(36).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/events/Freebie-Events-+Charity+Golf+Tournament+Fundraiser+Checklist.pdf",
    },
    {
      id: 25,
      title: "Pledge Card Templates",
      category: "Templates",
      description:
        "9 pledge card templates to help you boost donor commitments during campaigns",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(37).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/events/Freebie-Events-Pledge+Card+Templates.pdf",
    },
  ],

  // Build Donor Relationships
  donorRelationships: [
    {
      id: 10,
      title: "Raffle Prize Request Letter",
      category: "Letters",
      description:
        "Reach out to businesses with this ready-made template to secure raffle prizes",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(38).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Raffle%20Prize%20Donation%20Request%20Templates.pdf",
    },
    {
      id: 11,
      title: "Donor Call Script Templates",
      category: "Templates",
      description:
        "Customizable scripts to help your team build stronger donor relationships by phone",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(39).png",
      downloadUrl: "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Donor%20Phone%20Call%20Script%20Templates.pdf",
    },
    {
      id: 12,
      title: "Giving Tuesday Appeal Letter",
      category: "Letters",
      description:
        "Jumpstart your year-end giving with two ready-to-send letters for Giving Tuesday",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(40).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Giving%20Tuesday%20Letter%20Templates%20(1).pdf",
    },
    {
      id: 26,
      title: "Annual Appeal Letter Templates",
      category: "Templates",
      description:
        "Tried-and-true examples to inspire your year-end donation appeals",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(41).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/monthly%20giving/Freebie-Monthly%20Giving%20Appeal%20Template.pdf",
    },
    {
      id: 27,
      title: "School Donations Letter Pack",
      category: "Templates",
      description:
        "Templates made just for schools seeking donations or sponsorships",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(42).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Donation%20Letter%20Templates%20for%20Schools.pdf",
    },
    {
      id: 28,
      title: "Recurring Giving Starter Kit",
      category: "Worksheets",
      description:
        "A mini-course with videos and worksheets to launch or grow your monthly donor programs",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(43).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Recurring%20Giving%20Crash%20Course.pdf",
    },
    {
      id: 29,
      title: "Giving Tuesday Email Pack",
      category: "Emails",
      description:
        "Engage supporters before, during, and after Giving Tuesday with this 7-email set",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(44).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/giving+tuesday/Freebie-Giving%20Tuesday%20Day%20Reminder%20Templates.pdf",
    },
    {
      id: 31,
      title: "Pledge Reminder Letter",
      category: "Letters",
      description:
        "Gently nudge donors who pledged but haven't followed through—great for email or print",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(46).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Pledge%20Reminder%20Letter.pdf",
    },
    {
      id: 32,
      title: "Monthly Giving Outreach Templates",
      category: "Templates",
      description:
        "Use across channels to maintain engagement with recurring donors all year",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(47).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/monthly%20giving/Freebie-Monthly%20Giving%20Appeal%20Dedicated%20Project%20Template.pdf",
    },
    {
      id: 33,
      title: "Welcome Email Series",
      category: "Emails",
      description:
        "Onboarding new supporters with a 3-part welcome email sequence that builds connections",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(48).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Nonprofit%20Welcome%20Series%20Email%20Templates.pdf",
    },
    {
      id: 34,
      title: "DAF Outreach Email",
      category: "Emails",
      description:
        "Let donors know how easy it is to give through Donor-Advised Funds with this simple email",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(49).png",
      downloadUrl: "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Donor-Advised%20Fund%20Outreach%20Email%20Template.pdf",
    },
    {
      id: 35,
      title: "Annual Appeal Letter Templates Guide",
      category: "Templates",
      description:
        "Keep outreach organized with a free donor communications strategy template",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(50).png",
      downloadUrl: "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Annual%20Appeal%20Letter%20Templates%20Guide.pdf",
    },
    {
      id: 36,
      title: "Grant Funder Email Templates",
      category: "Templates",
      description:
        "Five templates to pitch your nonprofit to grant-making organizations",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(51).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Email%20Templates%20for%20Funder%20Outreach.pdf",
    },
    {
      id: 37,
      title: "Matching Gift Outreach Templates",
      category: "Templates",
      description:
        "A full set of messages to help you increase matching donations from individuals and employers",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(52).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Matching%20Gift%20Guide.pdf",
    },
  ],

  // Donor Stewardship & Retention
  donorStewardship: [
    {
      id: 13,
      title: "Moves Management Guide",
      category: "Guides",
      description:
        "A practical framework for strengthening long-term donor relationships—with templates included",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(53).png",
      downloadUrl: "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donor%20Movement%20Management%20Template%20(1).pdf",
    },
    {
      id: 14,
      title: "Donation Thank You Letter",
      category: "Letters",
      description:
        "Craft warm, personalized thank-you messages with two samples from real nonprofits",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(54).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Donation%20Thank%20You%20Letter.pdf",
    },
    {
      id: 15,
      title: "Year-End Appeal Guide",
      category: "Guides",
      description:
        "Create powerful end-of-year messages for email, print, and social—complete with examples",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(55).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Year-End%20Giving%20Appeal%20.pdf",
    },
    {
      id: 38,
      title: "Acknowledgement Letter Template",
      category: "Templates",
      description:
        "Send official tax-deductible acknowledgment letters with warmth and professionalism",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(56).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Donation%20Acknowledgment%20Letter%20.pdf",
    },
    {
      id: 39,
      title: "Donation Request Letter Pack",
      category: "Letters",
      description:
        "Five types of donation ask letters, all included in one easy-to-use bundle",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(57).png",
      downloadUrl: "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donation%20Request%20Template.pdf",
    },
    {
      id: 40,
      title: "Lapsed Donor Letter",
      category: "Letters",
      description:
        "Reconnected with past supporters using this re-engagement letter template",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(58).png",
      downloadUrl: "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/donors/Freebie-Donors-Annual%20Appeal%20Letter.pdf",
    },
  ],

  // Level Up Your Fundraising Campaigns
  levelUp: [
    {
      id: 16,
      title: "Summer Fundraising Checklist",
      category: "Checklists",
      description:
        "A seasonal checklist with smart ideas to boost your campaigns during the summer lull",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/Level+Up+Your+Fundraising+Campaigns.png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/fundraising/Freebie-Summer%20Fundraising%20Checklist.pdf",
    },
    {
      id: 18,
      title: "Corporate Sponsorship Thank You Letter",
      category: "Templates",
      description:
        "Show appreciation to your sponsors with this polished thank-you message",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(58).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/fundraising/Freebie-Corporate%20Sponsorship%20Thank%20You%20Letter%20Template.pdf",
    },
    {
      id: 41,
      title: "Corporate Sponsorship Proposal",
      category: "Templates",
      description:
        "A detailed template to help your nonprofit craft compelling sponsorship proposals for companies of all sizes—so you can secure the support you mission deserves",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(60).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/fundraising/Freebie-Corporate%20Sponsorship%20Proposal%20Template.pdf",
    },
    {
      id: 42,
      title: "Corporate Sponsorship Request Letter",
      category: "Templates",
      description:
        "Make a strong first impression with corporate sponsors using customizable language designed for your next event",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(61).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/fundraising/Freebie-Corporate%20Sponsorship%20Request%20Letter%20Template.pdf",
    },
    {
      id: 43,
      title: "Annual Fundraising Plan",
      category: "Templates",
      description:
        "Using this structured template to map our a full year of fundraising goals and action steps tailored to your nonprofit's growth",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(62).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/fundraising/Freebie-Annual%20Fundraising%20Plan%20Template.pdf",
    },
    {
      id: 44,
      title: "Raise $1K in 30 Days",
      category: "Guides",
      description:
        "Guide to help you bring in your first $1,000 in donations—whether you're just getting started or launching something new",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(63).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/fundraising/Freebie-How%20to%20Raise%20%241%2C000%20in%2030%20Days%20a%20Guide.pdf",
    },
    {
      id: 45,
      title: "Giving Tuesday Toolkit",
      category: "Guides",
      description:
        "Everything you need for Giving Tuesday in one place—emails, checklists, content ideas, and campaign planning tips",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(64).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/fundraising/Freebie-Giving%20Tuesday%20Playbook.pdf",
    },
    {
      id: 46,
      title: "Year-End Fundraising Checklist",
      category: "Checklists",
      description:
        "Wrap up your year strong with this step-by-step checklist designed to maximize donations and simplify your campaign planning",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(65).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/fundraising/Freebie-Year-End%20Fundraising%20Checklist.pdf",
    },
    {
      id: 47,
      title: "Giving Tuesday Social Media Checklist & Calendar",
      category: "Templates",
      description:
        "Plan your posts in advance and stay consistent with this calendar and content checklist built for Giving Tuesday success",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(66).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/fundraising/Freebie-Giving%20Tuesday%20Social%20Media%20Planning%20Checklist%20%26%20Calendar%20Template.pdf",
    },
    {
      id: 48,
      title: "Using the Power of Habit Design",
      category: "Guides",
      description:
        "Discover how to use habit-building strategies to create deeper donor relationships and long-term giving behavior",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(67).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/fundraising/Freebie-The%20Power%20of%20Habit%20Design%20to%20Increase%20Fundraising%20Success%20Guide.pdf",
    },
    {
      id: 49,
      title: "Nonprofit Grant Proposal",
      category: "Templates",
      description:
        "A 9-step framework for writing grant proposals that resonate with funders and stand out from the competition",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(68).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/fundraising/Freebie-Nonprofit%20Grant%20Proposal%20Guide.pdf",
    },
    {
      id: 50,
      title: "Peer-to-Peer Fundraising Toolkit",
      category: "Guides",
      description:
        "Unlock the power of your community with this toolkit designed to help you run effective and engaging peer-to-peer campaigns",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(69).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/fundraising/Freebie-Peer-to-Peer%20Fundraising%20Platform%20Buyer%27s%20Guide%20for%20Nonprofits.pdf",
    },
  ],

  // Optimize Operations
  optimize: [
    {
      id: 20,
      title: "The Perfect Nonprofit Pitch",
      category: "Worksheets",
      description:
        "Use this fill-in-the-blank worksheet to craft a short, powerful pitch that clearly conveys your mission and impact",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(74).png",
      downloadUrl: "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/streamine-non-profit/Freebie-The%20Quick%20Pitch%20Playbook.pdf",
    },
    {
      id: 21,
      title: "Nonprofit Business Plan",
      category: "Templates",
      description:
        "Plan for the future with this straightforward template that helps you outline goals, programs, and operations",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(75).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/streamine-non-profit/Freebie-Nonprofit%20Business%20Plan%20Template.pdf",
    },
    {
      id: 51,
      title: "Nonprofit Annual Report Template",
      category: "Templates",
      description:
        "Create a visually engaging, donor-focused annual report that showcases your organization's impact, and future goals",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(76).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/streamine-non-profit/Freebie-Nonprofit%20Annual%20Report%20Template.pdf",
    },
    {
      id: 52,
      title: "Pledge Agreement",
      category: "Templates",
      description:
        "Use this editable template to confirm pledges clearly and professionally, while keeping everything transparent and organized",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(77).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/streamine-non-profit/Freebie-Pledge%20Agreement%20Template.pdf",
    },
    {
      id: 54,
      title: "Nonprofit Strategic Planning",
      category: "Templates",
      description:
        "Get started on your next big chapter with a strategic plan template that helps guide your team toward mission-aligned outcomes",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(79).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/streamine-non-profit/Freebie-Strategic%20Planning%20Worksheet%20for%20Nonprofits.pdf",
    },
    {
      id: 55,
      title: "Nonprofit Marketing Plan",
      category: "Templates",
      description:
        "Bring structure to your outreach efforts with this marketing plan template built for team collaboration and clear goal-setting",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(80).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/streamine-non-profit/Freebie-Nonprofit%20Marketing%20Plan%20Template.pdf",
    },
    {
      id: 56,
      title: "How to Start a Nonprofit",
      category: "Guides",
      description:
        "New to the nonprofit world? This 10-step guide walks you through everything you need to get started—even on a shoestring budget",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(81).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/streamine-non-profit/Freebie-Quick%20Guide%2010%20Essential%20Steps%20to%20Launch%20a%20Nonprofit.pdf",
    },
    {
      id: 57,
      title: "Nonprofit Communications Plan",
      category: "Checklists",
      description:
        "Streamline your messaging with a communications plan that breaks down campaigns into simple, actionable pieces",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(82).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/streamine-non-profit/Freebie-Campaign%20Communications%20Playbook.pdf",
    },
    {
      id: 59,
      title: "Nonprofit Social Media Plan",
      category: "Templates",
      description:
        "Organize and grow your online presence with a social media strategy template made to build engagement and attract supporters",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/image+(84).png",
      downloadUrl:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/free-resources/pdfs/streamine-non-profit/Freebie-Social%20Media%20Guide%20for%20Nonprofits.pdf",
    },
  ],
};

// Utility function to get all resources as a flat array
export const getAllResources = () => {
  return [
    ...resourcesData.featured,
    ...resourcesData.maximize,
    ...resourcesData.organize,
    ...resourcesData.donorRelationships,
    ...resourcesData.donorStewardship,
    ...resourcesData.levelUp,
    ...resourcesData.optimize,
  ];
};

// Utility function to find a resource by ID
export const getResourceById = (id) => {
  const allResources = getAllResources();
  return allResources.find((resource) => resource.id === parseInt(id));
};

// Utility function to get related resources (same section/header, excluding current resource)
export const getRelatedResources = (currentResource) => {
  const allResources = getAllResources();

  // Find which section the current resource belongs to
  let currentSection = null;
  for (const [sectionName, resources] of Object.entries(resourcesData)) {
    if (resources.find((resource) => resource.id === currentResource.id)) {
      currentSection = sectionName;
      break;
    }
  }

  // Get resources from the same section
  let relatedResources = [];
  if (currentSection && resourcesData[currentSection]) {
    relatedResources = resourcesData[currentSection].filter(
      (resource) => resource.id !== currentResource.id
    );
  }

  // If no resources in same section, get any other resources
  if (relatedResources.length === 0) {
    relatedResources = allResources.filter(
      (resource) => resource.id !== currentResource.id
    );
  }

  return relatedResources;
};
